import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const API = process.env.REACT_APP_API_URL || '';

export default function VerifyRedirect() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying');
  const navigate = useNavigate(); // eslint-disable-line no-unused-vars
  const { login } = useAuth(); // eslint-disable-line no-unused-vars

  const code = searchParams.get('code');
  const email = searchParams.get('email');

  useEffect(() => {
    if (!code || !email) {
      setStatus('error');
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${API}/api/auth/verify-magic-link`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, code }),
        });

        if (!res.ok) throw new Error('Verification failed');

        const data = await res.json();
        // Log the user in with the returned token
        if (data.token) {
          localStorage.setItem('token', data.token);
          if (data.user) localStorage.setItem('user', JSON.stringify(data.user));
          window.location.href = '/';
        } else {
          setStatus('error');
        }
      } catch (err) {
        console.error('Magic link verify error:', err);
        setStatus('error');
      }
    })();
  }, [code, email]);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (status === 'verifying') {
    return (
      <div style={styles.container}>
        <div style={styles.spinner} />
        <h2 style={styles.title}>Opening Tract...</h2>
        <p style={styles.subtitle}>Verifying your login</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Verification failed</h2>
      <p style={styles.subtitle}>
        The link may have expired. Please request a new login code.
      </p>
      {isMobile && (
        <a
          href="https://apps.apple.com/app/tract-gut-health/id6742598195"
          style={styles.button}
        >
          Download Tract
        </a>
      )}
      <a href="/login" style={{ ...styles.button, marginTop: 12, background: 'transparent', color: '#7E8B47', border: '2px solid #7E8B47' }}>
        Back to Login
      </a>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: 24,
    fontFamily: "'Inter', -apple-system, sans-serif",
    color: '#4A2E1F',
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    margin: '16px 0 8px',
  },
  subtitle: {
    fontSize: 16,
    color: '#5C4A3A',
    textAlign: 'center',
    maxWidth: 320,
  },
  button: {
    display: 'inline-block',
    background: '#7E8B47',
    color: '#fff',
    textDecoration: 'none',
    padding: '14px 32px',
    borderRadius: 14,
    fontWeight: 600,
    fontSize: 16,
    marginTop: 24,
  },
  spinner: {
    width: 40,
    height: 40,
    border: '4px solid #F5F0EB',
    borderTop: '4px solid #7E8B47',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
};
